export default __webpack_public_path__ + "static/media/icon-align.ee615802.png";